<template>
  <div>
    <a-row>
      <g-master name="Resultado Final"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :parentData="parentData"
                :modalFieldsSetup="master.modalFieldsSetup"
                @action="masterAction"
                modalWidth="100%"
                ref="master"
      >
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Evaluación Final Del Jefe')"
                          :formItemConfig="fiOptions"
                          :decorator="['end_evaluation_boss', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="eva_comp_escala">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Autoevaluación Final Del Colaborador')"
                          :formItemConfig="fiOptions"
                          :decorator="['end_auto_evaluation_employee', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="eva_comp_escala">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Evaluación Final Ponderada')">
                <a-input disabled style="color: black"
                         v-decorator="['weighted_end_evaluation', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Descripción Cualitativa Final')">
                <a-textarea autoSize
                            v-decorator="['end_description', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Brecha Inicial')">
                <a-input disabled style="color: black"
                         v-decorator="['end_difference', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Resultado Dominio Final (%)')">
                <a-input disabled style="color: black"
                         v-decorator="['final_result', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Valoración Final')">
                <a-input disabled style="color: black"
                         v-decorator="['final_value', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Compromiso Para Próximo Período')">
                <a-textarea autoSize
                            v-decorator="['commitments', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: ['id_competencia', 'id_emp'],
    data () {
      return {
        seguir1: true,
        seguir2: true,
        eva_comp_escala: {
          h_lookup_type: 'EVA_COMP_ESCALA',
          use_description: true
        },
        selOptions: {
          allowClear: true
        },
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'eva_comp_resultado_final',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {
                title: 'Evaluación Final Jefe (60%)',
                dataIndex: 'end_evaluation_boss',
                align: 'center',
                sorter: true,
                width: 170
              },
              {
                title: 'Autoevaluación Final Colaborador (40%)',
                dataIndex: 'end_auto_evaluation_employee',
                align: 'center',
                sorter: true,
                width: 200
              },
              {
                title: 'Evaluación Final Ponderada',
                dataIndex: 'weighted_end_evaluation',
                align: 'center',
                sorter: true,
                width: 170
              },
              {
                title: 'Descripción Cualitativa Final ',
                dataIndex: 'end_description',
                align: 'center',
                sorter: true,
                width: 400
              },
              {title: 'Brecha Final', dataIndex: 'end_difference', align: 'center', sorter: true},
              {
                title: 'Resultado Dominio Final (%)',
                dataIndex: 'final_result',
                align: 'center',
                sorter: true,
                width: 150
              },
              {title: 'Valoración Final', dataIndex: 'final_value', align: 'center', sorter: true},
              {title: 'Compromiso Para Próximo Período', dataIndex: 'commitments', align: 'center', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'end_evaluation_boss'},
            {name: 'end_auto_evaluation_employee'},
            {name: 'end_description'},
            {name: 'commitments'}
          ],
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'fieldsChange':
            if (!JsUtils.isEmpty(action.changedFields) && !JsUtils.isEmpty(action.changedFields.end_evaluation_boss)) {
              this.end_evaluation_boss = action.changedFields.end_evaluation_boss.value
              // this.seguir1 = true
            }

            if (!JsUtils.isEmpty(action.changedFields) && !JsUtils.isEmpty(action.changedFields.end_auto_evaluation_employee)) {
              this.end_auto_evaluation_employee = action.changedFields.end_auto_evaluation_employee.value
              // this.seguir2 = true
            }

            if (this.seguir1 && this.seguir2 &&
              !JsUtils.isEmpty(this.end_evaluation_boss) && !JsUtils.isEmpty(this.end_auto_evaluation_employee)) {
              this.calculaResultado(this.end_evaluation_boss, this.end_auto_evaluation_employee, this.id_competencia, this.id_emp)
              this.seguir1 = false
              this.seguir2 = false
            }
            break
        }
      },
      calculaResultado (evaJefe, autoEvaEmp, competencia, empleado) {
        this.httpClient.getInstance().post('eva_comp_resultado_final_calcula_datos', {
          end_evaluation_boss: evaJefe,
          end_auto_evaluation_employee: autoEvaEmp,
          id_eva_competencia: competencia,
          id_emp: empleado
        })
          .then((response) => {
            this.$refs.master.modal.form.setFieldsValue({
              weighted_end_evaluation: response.data[0]['efp'],
              end_difference: response.data[0]['bf'],
              final_result: response.data[0]['rdfc'],
              final_value: response.data[0]['vfc']
            })
            this.seguir1 = true
            this.seguir2 = true
          })
          .catch((error) => {
            Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible calcular el valor, contacte al administrador.'))
            this.seguir1 = true
            this.seguir2 = true
          })
      }
    },
    computed: {
      parentData () {
        return {
          id_eva_competency: this.id_competencia,
          id_emp: this.id_emp
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Evaluaciones/Complemento/CompResultadoFinal.vue